import React from 'react';
import Card from 'react-bootstrap/Card';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useComponent } from '../../../Pages/UserSetting/UsersLibrary/UserRights';
import { shortenStringWithTooltip } from '../../helper';

function BomLibraryGroupCard({ item, index, onCheck, paramId, onDelete, selectedIds, catBasedOnPTData }) {
  const { t } = useTranslation('common');

  const isChecked = selectedIds.filter((val) => val === item._id).length > 0;

  const {
    Users: { logInRights },
  } = useSelector((redState) => redState);

  const { CheckActionPermission } = useComponent();
  const BomLibraryAddEditAccess = CheckActionPermission(logInRights, 'libraries', 'bom', 'addEdit');
  const BomLibraryDeleteAccess = CheckActionPermission(logInRights, 'libraries', 'bom', 'delete');

  return (
    <div id="accordion" className="col-lg-3">
      <Card className="common-listing-card bom-group-card mb-16">
        <Card.Header>
          <ul className="card-header-icon bom-card-header">
            {(BomLibraryAddEditAccess || BomLibraryDeleteAccess) && (
              <li>
                <div className="common-checkbox size-sm">
                  <input
                    onChange={(e) => {
                      onCheck(e, item._id, index);
                    }}
                    name={`check_${index}`}
                    id={`check_${index}`}
                    type="checkbox"
                    checked={isChecked}
                  />
                  <label htmlFor={`check_${index}`} className="chklabel" />
                </div>
              </li>
            )}
            {BomLibraryAddEditAccess && (
              <li>
                <Link
                  className="cursor-pointer text-dark text-decoration-none"
                  to={`/libraries/bom-library-group/edit/${paramId}/${item._id}`}
                  state={{ from: 'occupation' }}
                >
                  <i className="icon-Edit-1" />
                </Link>
              </li>
            )}
            {BomLibraryDeleteAccess && (
              <li>
                <button
                  type="button"
                  aria-label="delete"
                  className="btn p-0"
                  title={t('BOM_LIBRARY_GROUP_CARD.DELETE_TITLE')}
                  onClick={() => {
                    onDelete(item._id);
                  }}
                >
                  <i className="icon-Delete" />
                </button>
              </li>
            )}
          </ul>
        </Card.Header>
        <Card.Body>
          <ul className="card-ul">
            <li>
              <strong>{t('BOM_LIBRARY_GROUP_CARD.GROUP_NAME')}:</strong> {item?.name ? shortenStringWithTooltip(item.name, 15) : ''}
            </li>
            <li>
              <strong>{t('BOM_LIBRARY_GROUP_CARD.GROUP_DESCRIPTION')}:</strong> {item?.description ? shortenStringWithTooltip(item.description, 15) : ''}
            </li>

            <li>
              <strong>{t('BOM_LIBRARY_GROUP_CARD.SEASON_YEAR')}:</strong> {item?.seasonId?.name ? item.seasonId.name : '-'} {item.year ? ` / ${item.year}` : ''}
            </li>
            {catBasedOnPTData && (
              <li>
                <strong>{t('BOM_LIBRARY_GROUP_CARD.PRODUCT_TYPE')}:</strong>{' '}
                {item?.productType?.name ? shortenStringWithTooltip(item.productType.name, 14) : ''}
              </li>
            )}

            <li>
              <strong>{t('BOM_LIBRARY_GROUP_CARD.CATEGORY_1')}:</strong> {item?.catOne?.name ? shortenStringWithTooltip(item.catOne.name, 14) : ''}
            </li>

            <li>
              <strong>{t('BOM_LIBRARY_GROUP_CARD.CATEGORY_2')}:</strong> {item?.catTwo?.name ? shortenStringWithTooltip(item.catTwo.name, 14) : ''}
            </li>

            <li>
              <strong>{t('BOM_LIBRARY_GROUP_CARD.CATEGORY_3')}:</strong> {item?.catThree?.name ? shortenStringWithTooltip(item.catThree.name, 14) : ''}
            </li>

            <li>
              <strong>{t('BOM_LIBRARY_GROUP_CARD.CREATED')}:</strong> {item?.createdBy} | {moment(item.createdAt).format('DD-MMM-YYYY ')}|{' '}
              <span> {moment(item.createdAt).format('hh:mm A')} </span>
            </li>
            <li>
              <strong>{t('BOM_LIBRARY_GROUP_CARD.MODIFIED')}:</strong> {item.modifiedBy || item.createdBy} |{' '}
              {moment(item.updatedAt || item.createdAt).format('DD-MMM-YYYY ')}| <span>{moment(item.updatedAt || item.createdAt).format('hh:mm A')} </span>
            </li>
          </ul>
        </Card.Body>
      </Card>
    </div>
  );
}

export default BomLibraryGroupCard;
